<script>
    export let size = 24
    export let color = '#C5281C'
    export let style = ''
    export let title = null
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 512 512"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <polyline
        points="328 112 184 256 328 400"
        style={`fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-width:48px`}
    ></polyline>
</svg>
